import { handleActions } from 'redux-actions';

import OpmServiceModel from 'models/api/opm-service-model';
import {
  setOpmServiceStatusForBanner,
  resetOpmServiceStatusForBanner,
} from 'store/actions/opm-service-actions';

export default handleActions(
  {
    [setOpmServiceStatusForBanner]: (opmService, { payload }) => {
      return opmService.setOpmServiceStatusForBanner(payload);
    },
    [resetOpmServiceStatusForBanner]: (opmService) => {
      return opmService.setOpmServiceStatusForBanner(null);
    },
  },
  new OpmServiceModel(),
);
